import humps from 'lodash-humps-ts';

import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { WithParams } from '@utils/typescript';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { Document, DocumentTypes } from '@models/Document';

export type GetAllDocumentParams = PaginationParams & WithParams<{
  documentable_type: string;
  documentable_id: number;
  document_type: DocumentTypes | '';
}>;

export type CreateDocumentParams = WithParams<{
  documentable_type: string;
  documentable_id: number;
  document_type: DocumentTypes | '';
  name: string;
  document: File | undefined;
}>;

export class DocumentApi {
  static getAll = async (params: GetAllDocumentParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/documents`, { params: snakes(params) })
      .then((response) => paginate(response) as [Document[], Pagination]);
  };

  static create = async (params: CreateDocumentParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/documents`, snakes(params))
      .then((response) => humps(response.data) as Document);
  };
}
